import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../authProvider";

export default function RedirectIfAuthenticated({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useAuthStore();

  if (user) {
    return <Navigate to="/" />;
  }

  return children;
}
